import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export function Layout() {
  // Fable Ops (/ops) brings its own navigation and footer, so the Fable+ chrome steps aside there.
  const ops = useLocation().pathname.startsWith("/ops");
  return (
    <div className="flex min-h-screen flex-col">
      {ops ? null : <Navbar />}
      <main className="flex-1">
        <Outlet />
      </main>
      {ops ? null : <Footer />}
    </div>
  );
}
